import React, { useEffect, useRef } from "react";

const AUTO_SCROLL_SPEED = 0.5;

const CommunityMarquee = ({ list }) => {
  const wrapperRef = useRef(null);
  const isPaused = useRef(false);
  const frameRef = useRef(null);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const step = () => {
      if (!isPaused.current) {
        wrapper.scrollLeft += AUTO_SCROLL_SPEED;
        const halfWidth = wrapper.scrollWidth / 2;
        if (wrapper.scrollLeft >= halfWidth) {
          wrapper.scrollLeft -= halfWidth;
        }
      }
      frameRef.current = requestAnimationFrame(step);
    };
    frameRef.current = requestAnimationFrame(step);

    const handleWheel = (e) => {
      const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      wrapper.scrollLeft += delta;
      e.preventDefault();
    };

    const pause = () => {
      isPaused.current = true;
    };
    const resume = () => {
      isPaused.current = false;
    };

    wrapper.addEventListener("wheel", handleWheel, { passive: false });
    wrapper.addEventListener("mouseenter", pause);
    wrapper.addEventListener("mouseleave", resume);
    wrapper.addEventListener("touchstart", pause, { passive: true });
    wrapper.addEventListener("touchend", resume);

    return () => {
      cancelAnimationFrame(frameRef.current);
      wrapper.removeEventListener("wheel", handleWheel);
      wrapper.removeEventListener("mouseenter", pause);
      wrapper.removeEventListener("mouseleave", resume);
      wrapper.removeEventListener("touchstart", pause);
      wrapper.removeEventListener("touchend", resume);
    };
  }, []);

  return (
    <div className="rn-marquee-wrapper" ref={wrapperRef}>
      <div className="rn-marquee-track">
        {list.concat(list).map((value, index) => (
          <div className="single_im_portfolio rn-marquee-item" key={index}>
            <div className="im_portfolio">
              <div className="thumbnail_inner">
                <div className="thumbnail">
                  {value.image}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunityMarquee;
